import { render, staticRenderFns } from "./EventsBookingsDataTable.vue?vue&type=template&id=1c7c64d7"
import script from "./EventsBookingsDataTable.vue?vue&type=script&lang=js"
export * from "./EventsBookingsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports